import React from "react";

// Icon Button - Compact actions
export const IconButton = ({
  icon: Icon,
  onClick,
  variant = "primary",
  size = "md",
  disabled = false,
  className = "",
  ...props
}) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
  };

  const variantClasses = {
    primary: "bg-brand-gold text-brand-charcoal hover:bg-brand-gold/90",
    secondary: "bg-brand-cream text-brand-charcoal border border-brand-charcoal/20 hover:bg-brand-charcoal/5",
    danger: "bg-red-600 text-white hover:bg-red-700",
    success: "bg-brand-charcoal text-brand-cream hover:bg-brand-charcoal/90",
    ghost: "bg-transparent text-brand-muted hover:bg-brand-charcoal/5 hover:text-brand-charcoal",
  };

  // Safety check to ensure Icon is a valid component
  if (!Icon || typeof Icon !== "function") {
    // Only warn in development mode to avoid console spam
    if (process.env.NODE_ENV === "development") {
      console.warn("IconButton: icon prop must be a valid React component", {
        Icon,
        type: typeof Icon,
        props: { icon: Icon, onClick, variant, size, disabled, className },
      });
    }
    // Return a fallback button instead of null to prevent layout issues
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        className={`
          ${sizeClasses[size]} max-lg:min-h-11 max-lg:min-w-11 ${variantClasses[variant]}
          rounded-lg flex items-center justify-center
          focus:outline-none focus:ring-2 focus:ring-offset-2
          transition-all duration-200
          disabled:opacity-50 disabled:cursor-not-allowed
          ${className}
        `}
        {...props}
      >
        <span className="text-xs">?</span>
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${sizeClasses[size]} max-lg:min-h-11 max-lg:min-w-11 ${variantClasses[variant]}
        rounded-lg flex items-center justify-center
        focus:outline-none focus:ring-2 focus:ring-offset-2
        transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    >
      <Icon className="w-4 h-4" />
    </button>
  );
};

export default IconButton;
